import { render, staticRenderFns } from "./TasksSelectModal.vue?vue&type=template&id=9cb27d32&scoped=true"
import script from "./TasksSelectModal.vue?vue&type=script&lang=js"
export * from "./TasksSelectModal.vue?vue&type=script&lang=js"
import style0 from "./TasksSelectModal.vue?vue&type=style&index=0&id=9cb27d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb27d32",
  null
  
)

export default component.exports